import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {

  constructor(private snackbar: MatSnackBar, private translate: TranslateService) {
    translate.setDefaultLang("it");
  }

  ngOnInit() {
    // NUOVO: Applica il tema del brand prima di tutto
    this.applyBrandTheme();

    if (!environment.production) {
      // Aggiornato per mostrare anche il brand attivo
      const message = `Modalità di Sviluppo Attiva - ${environment.brand.name}`;
      this.snackbar.open(message, "X", { 
        duration: 4000,
        panelClass: 'generic-snackbar'  // Usa la classe con colori dinamici
      });
    }
  }

  // NUOVO: Metodo per applicare il tema dinamico
private applyBrandTheme() {
  const root = document.documentElement;
  const body = document.body;
  const theme = environment.brand.theme;
  
  // Imposta attributo data-brand sul body per CSS specifici
  body.setAttribute('data-brand', environment.brand.type);
  
  // Sovrascrivi le variabili CSS globalmente
  root.style.setProperty('--primary-color', theme.primaryColor);
  root.style.setProperty('--secondary-color', theme.secondaryColor);
  root.style.setProperty('--brand-primary', theme.primaryColor);
  root.style.setProperty('--brand-secondary', theme.secondaryColor);
  root.style.setProperty('--brand-login-bg', `url('${theme.loginBackground}')`);
  root.style.setProperty('--brand-bg-color', theme.bgColor);





  
  // Log per debug
  console.log(`Tema applicato: ${environment.brand.name} (${environment.brand.type})`);
  console.log(`Colore primario: ${theme.primaryColor}`);
}

}